import React from 'react';
import { useDict } from '../contexts/LanguageContext';

const WelcomeLine = ({ name }) => {
    const dict = useDict();

    return (
        <div className="welcome-greeting" data-cy="dashboard__welcome">
            <h3 className="page-title">
                <span className="text-orange">{dict.welcome},</span> {name}!
            </h3>
        </div>
    );
};

WelcomeLine.defaultProps = {
    name: 'N/A',
};

export default WelcomeLine;
